export default __webpack_public_path__ + "static/media/footer-icon-aurora.90725a23.svg";